
import { useState, useEffect } from "react";
import "./Payment.css";
import { FaWallet, FaCreditCard, FaBuilding, FaUser, FaDownload, FaFilter, FaTimes, FaPlus, FaHistory, FaRupeeSign, FaCalendarAlt, FaClock } from "react-icons/fa";
import axios from "axios";

const Payment = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [transactions, setTransactions] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [useCashback, setUseCashback] = useState(false);


  const [wallet, setWallet] = useState({
    totalBalance: 0,
    cashbackAmount: 0,
    companyLoadedAmount: 0,
    selfLoadedAmount: 0,
  });

  const storedUserId = localStorage.getItem("userId");
  const userId = storedUserId ? parseInt(storedUserId, 10) : null;

  const handleOpen = () => setShowPopup(true);
  const handleClose = () => setShowPopup(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch wallet data
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) return;

    const fetchWallet = async () => {
      try {
        const response = await axios.get(
          `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
        setWallet(response.data);
      } catch (error) {
        console.error("Error fetching wallet data:", error);
      }
    };

    fetchWallet();
  }, []);

  // Fetch transactions
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) {
      console.error("User ID not found in localStorage");
      return;
    }

    axios
      .get(
        `https://backend.maamaas.com/subscription/api/user/wallet/transactions/${userId}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      )
      .then((res) => {
        setTransactions(res.data);
      })
      .catch((err) => {
        console.error("Error fetching transactions:", err);
      });
  }, []);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleSubmit = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("authToken");

      if (!userId || !amount) {
        alert("Please fill all fields");
        return;
      }

      /* ---------------- CALCULATIONS ---------------- */
      const enteredAmount = Number(amount);
      const cashbackAvailable = wallet?.cashbackAmount || 0;

      const cashbackUsed = useCashback
        ? Math.min(cashbackAvailable, enteredAmount)
        : 0;

      const payableAmount = enteredAmount - cashbackUsed;

      // ✅ Razorpay needs PAISE
      const amountInPaise = Math.round(payableAmount);

      /* ---------------- RAZORPAY AUTH ---------------- */
      const username = "rzp_live_RU5whSMu9rPV7s";
      const password = "khRC0vtSHCGHktyu62yekZp0";
      const basicAuth = btoa(`${username}:${password}`);

      const loaded = await loadRazorpayScript();
      if (!loaded) {
        alert("Razorpay SDK failed to load.");
        return;
      }

      /* ---------------- CREATE ORDER ---------------- */
      const createOrderRes = await axios.post(
        "https://backend.maamaas.com/subscription/api/user/create-order",
        {
          amount: amountInPaise,
          currency: "INR",
          vendorId: userId,
        },
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
            "Content-Type": "application/json",
          },
        }
      );

      const orderId = createOrderRes?.data?.orderId;
      if (!orderId) {
        alert("Order ID missing from backend");
        return;
      }

      /* ---------------- RAZORPAY CHECKOUT ---------------- */
      const options = {
        key: username,
        amount: amountInPaise, // ✅ 99000
        currency: "INR",
        name: "Maamaa's House",
        description: `Wallet Load (₹${enteredAmount} - Cashback ₹${cashbackUsed})`,
        order_id: orderId,

        handler: async function (response) {
          const paymentId = response.razorpay_payment_id;

          try {
            /* -------- CAPTURE PAYMENT -------- */
            await axios.post(
              "https://backend.maamaas.com/subscription/api/user/capture",
              {
                paymentId,
                amount: amountInPaise,
                currency: "INR",
                vendorId: userId,
              },
              {
                headers: { Authorization: `Basic ${basicAuth}` },
              }
            );

            /* -------- UPDATE WALLET (FIXED URL) -------- */
            await axios.post(
              "https://backend.maamaas.com/subscription/api/user/profesional/self-loaded",
              null,
              {
                params: {
                  userId: Number(userId),
                  amount: enteredAmount,   // ✅ 1000
                  paymentId: String(paymentId),
                  orderId: Number(orderId),
                  useCashback: Boolean(useCashback),
                },
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            // alert("Wallet loaded successfully!");
            window.location.reload();

          } catch (err) {
            // console.error("❌ Wallet update failed:", err?.response || err);
            alert("Payment successful, but wallet update failed.");
          }
        },

        theme: { color: "#ee6521" },
      };

      new window.Razorpay(options).open();

    } catch (err) {
      console.error("❌ Razorpay init error:", err);
      alert("Order creation failed");
    }
  };




  const openTransactionDetails = (transaction) => {
    setSelectedTransaction(transaction);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTransaction(null);
  };
  const enteredAmount = Number(amount);

  const cashbackAvailable = wallet?.cashbackAmount || 0;

  const cashbackUsed = useCashback
    ? Math.min(cashbackAvailable, enteredAmount)
    : 0;

  const payableAmount = enteredAmount - cashbackUsed;



  // Pagination
  const rowsPerPage = isMobile ? 5 : 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentTransactions = transactions.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(transactions.length / rowsPerPage);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const getTransactionIcon = (type) => {
    switch (type) {
      case 'CREDIT': return '🟢';
      case 'DEBIT': return '🔴';
      default: return '⚪';
    }
  };

  return (
    <div className="payment-container">
      {/* Header Section */}
      <div className="payment-header">

        {/* s */}
      </div>

      {/* Wallet Cards Section */}
      <div className="wallet-cards">
        <div className="wallet-card total-balance">

          <div className="card-content">
            <h3 className="card-title">Total Balance</h3>
            <p className="card-amount">₹{wallet.totalBalance}</p>
          </div>
        </div>

        <div className="wallet-card cashback">

          <div className="card-content">
            <h3 className="card-title">Cashback</h3>
            <p className="card-amount">₹{wallet.cashbackAmount}</p>
          </div>
        </div>

        <div className="wallet-card company">

          <div className="card-content">
            <h3 className="card-title">Company Loaded</h3>
            <p className="card-amount">₹{wallet.companyLoadedAmount}</p>
          </div>
        </div>

        <div className="wallet-card self">

          <div className="card-content">
            <h3 className="card-title">Self Loaded</h3>
            <p className="card-amount">₹{wallet.selfLoadedAmount}</p>
          </div>
        </div>

        <div className="wallet-card load-wallet">
          <div className="card-content">
            <h3 className="card-title"> Wallet</h3>
            <button className="load-btn" onClick={handleOpen}>
              <FaPlus />
              Add Money
            </button>
          </div>
        </div>
      </div>

      {/* Transactions Section */}
      <div className="transactions-section">
        <div className="section-header">
          <div className="section-title">
            <FaHistory />
            <h2>Transaction History</h2>
          </div>
          <div className="section-actions">
            {/* <button className="filter-btn">
              <FaFilter />
              Filter
            </button> */}
          </div>
        </div>

        {isMobile ? (
          /* Mobile Cards View */
          <div className="transaction-cards">
            {currentTransactions.length > 0 ? (
              currentTransactions.map((transaction, index) => (
                <div
                  key={transaction.id || index}
                  className="transaction-card"
                  onClick={() => openTransactionDetails(transaction)}
                >
                  <div className="transaction-header">
                    <div className="transaction-type">
                      <span className="type-icon">
                        {getTransactionIcon(transaction.transactionType)}
                      </span>
                      <span className="type-text">{transaction.transactionType}</span>
                    </div>
                    <div
                      className={`transaction-amount ${transaction.transactionType === 'CREDIT' ? 'credit' : 'debit'}`}
                    >
                      {transaction.transactionType === 'CREDIT' ? '+' : '-'}₹{transaction.amount}
                    </div>
                  </div>

                  <div className="transaction-details">
                    <div className="detail-row">
                      <span className="label">Balance Type:</span>
                      <span className="value">{transaction.balanceType}</span>
                    </div>
                    <div className="detail-row">
                      <span className="label">Date:</span>
                      <span className="value">
                        <FaCalendarAlt /> {formatDate(transaction.transactionTime)}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="label">Time:</span>
                      <span className="value">
                        <FaClock /> {formatTime(transaction.transactionTime)}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <div className="empty-icon">📊</div>
                <h3>No Transactions Found</h3>
                <p>Your transaction history will appear here</p>
              </div>
            )}
          </div>
        ) : (
          /* Desktop Table View */
          <div className="transactions-table-container">
            <table className="transactions-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date & Time</th>
                  <th>Transaction Type</th>
                  <th>Amount</th>
                  <th>Balance Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentTransactions.length > 0 ? (
                  currentTransactions.map((transaction, index) => (
                    <tr key={transaction.id || index}>
                      <td className="serial-number">{indexOfFirstRow + index + 1}</td>
                      <td className="datetime-cell">
                        <div className="date-time">
                          <div className="date">
                            <FaCalendarAlt /> {formatDate(transaction.transactionTime)}
                          </div>
                          <div className="time">
                            <FaClock /> {formatTime(transaction.transactionTime)}
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className={`transaction-type-badge ${transaction.transactionType.toLowerCase()}`}>
                          {transaction.transactionType}
                        </span>
                      </td>
                      <td
                        className={`amount-cell ${transaction.transactionType === 'CREDIT' ? 'credit' : 'debit'}`}
                      >
                        {transaction.transactionType === 'CREDIT' ? '+' : '-'}₹{transaction.amount}
                      </td>
                      <td className="balance-type">{transaction.balanceType}</td>
                      <td>
                        <button
                          className="view-details-btn"
                          onClick={() => openTransactionDetails(transaction)}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="no-transactions">
                      <div className="empty-state">
                        <div className="empty-icon">📊</div>
                        <h3>No Transactions Found</h3>
                        <p>Your transaction history will appear here</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        {transactions.length > 0 && (
          <div className="pagination">
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="pagination-btn prev"
            >
              Previous
            </button>

            <div className="page-info">
              Page {currentPage} of {totalPages}
            </div>

            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="pagination-btn next"
            >
              Next
            </button>
          </div>
        )}
      </div>

      {/* Load Wallet Modal */}
      {showPopup && (
        <div className="modal-overlay">
          <div className="modal-contenty">
            <div className="modal-header">
              <h2>Load Wallet</h2>
              <button className="close-btn" onClick={handleClose}>
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">

              {/* ENTER AMOUNT */}
              <div className="form-group">
                <label>Enter Amount</label>
                <div className="amount-input">
                  <FaRupeeSign className="input-icon" />
                  <input
                    type="number"
                    placeholder="Enter amount to load"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    min="1"
                  />
                </div>
              </div>

              {/* QUICK SELECT */}
              <div className="quick-amounts">
                <span>Quick Select:</span>
                <div className="amount-buttons">
                  {[100, 200, 500, 1000, 2000].map(quickAmount => (
                    <button
                      key={quickAmount}
                      className="quick-amount-btn"
                      onClick={() => setAmount(quickAmount.toString())}
                    >
                      ₹{quickAmount}
                    </button>
                  ))}
                </div>
              </div>

              {/* ✅ CASHBACK CARD INSIDE POPUP */}
              <div className="wallet-card cashback">
                <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <input
                    type="checkbox"
                    checked={useCashback}
                    disabled={wallet.cashbackAmount <= 0}
                    onChange={(e) => setUseCashback(e.target.checked)}
                  />
                  <div className="card-content">
                    <h3 className="card-title">Use Cashback</h3>
                    <p className="card-amount">
                      Available: ₹{wallet.cashbackAmount}
                    </p>
                  </div>
                </label>
              </div>

              {/* ✅ AMOUNT SUMMARY */}
              <div style={{ marginTop: "15px", fontSize: "14px" }}>
                <p>Entered Amount: ₹{enteredAmount}</p>
                {useCashback && (
                  <p style={{ color: "green" }}>
                    Cashback Used: −₹{cashbackUsed}
                  </p>
                )}
                <p style={{ fontWeight: "bold" }}>
                  Payable Amount: ₹{payableAmount}
                </p>
              </div>

            </div>

            <div className="modal-actions">
              <button className="cancel-btn" onClick={handleClose}>
                Cancel
              </button>

              <button
                className="submit-btn"
                onClick={() => handleSubmit(payableAmount, cashbackUsed)}
                disabled={payableAmount <= 0}
              >
                Proceed to Pay ₹{payableAmount}
              </button>
            </div>
          </div>
        </div>
      )}


      {/* Transaction Details Modal */}
      {isModalOpen && selectedTransaction && (
        <div className="modal-overlay">
          <div className="modal-contenty">
            <div className="modal-header">
              <h2>Transaction Details</h2>
              <button className="close-btn" onClick={closeModal}>
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">
              <div className="transaction-detail-grid">
                <div className="detail-item">
                  <span className="detail-label">Transaction ID:</span>
                  <span className="detail-value">{selectedTransaction.id || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Type:</span>
                  <span className={`detail-value type-badge ${selectedTransaction.transactionType.toLowerCase()}`}>
                    {selectedTransaction.transactionType}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Amount:</span>
                  <span className={`detail-value amount ${selectedTransaction.transactionType === 'CREDIT' ? 'credit' : 'debit'}`}>
                    {selectedTransaction.transactionType === 'CREDIT' ? '+' : '-'}₹{selectedTransaction.amount}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Balance Type:</span>
                  <span className="detail-value">{selectedTransaction.balanceType}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Date:</span>
                  <span className="detail-value">
                    <FaCalendarAlt /> {formatDate(selectedTransaction.transactionTime)}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Time:</span>
                  <span className="detail-value">
                    <FaClock /> {formatTime(selectedTransaction.transactionTime)}
                  </span>
                </div>
              </div>

              <div className="transaction-description">
                <h4>Description</h4>
                <p>
                  This {selectedTransaction.transactionType.toLowerCase()} transaction was successfully processed.
                  {selectedTransaction.transactionType === 'CREDIT'
                    ? ' The amount has been added to your wallet balance.'
                    : ' The amount has been deducted from your wallet balance.'
                  }
                  Please check your account for confirmation and contact support if you don't see the transaction
                  reflected within 24 hours.
                </p>
              </div>
            </div>

            <div className="modal-actions">
              <button
                className="close-details-btn"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default Payment;